import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import StoreModal from '../../components/stores/StoreModal';
import { getMyStores, getVirtualNumber } from '../../api/stores';


const StoresPage = () => {
    const navigate = useNavigate();
    const [스토어목록, set스토어목록] = useState([]);
    const [로딩중, set로딩중] = useState(true);
    const [에러, set에러] = useState(null);
    const [모달열림, set모달열림] = useState(false);

    const 데이터로드 = () => {
        set로딩중(true);
        getMyStores()
            .then(async (data) => {
                const 목록 = Array.isArray(data) ? data : [];
                const 가상번호목록 = await Promise.all(목록.map((s) => getVirtualNumber(s.uuid)));
                set스토어목록(목록.map((s, i) => ({ ...s, virtualNumber: 가상번호목록[i] })));
            })
            .catch(() => {
                set에러('스토어 목록을 불러오지 못했습니다.');
            })
            .finally(() => {
                set로딩중(false);
            });
    };

    useEffect(() => {
        데이터로드();
    }, []);

    return (
        <PageWrapper>
            <Contents>
                <TitleRow>
                    <PageTitle>내 스토어</PageTitle>
                    {/* <AddButton onClick={() => set모달열림(true)}>+ 스토어 추가</AddButton> */}
                </TitleRow>

                {로딩중 && (
                    <StatusText>불러오는 중...</StatusText>
                )}

                {!로딩중 && 에러 && (
                    <StatusText $error>{에러}</StatusText>
                )}

                {!로딩중 && !에러 && 스토어목록.length === 0 && (
                    <StatusText>등록된 스토어가 없습니다.</StatusText>
                )}

                {!로딩중 && !에러 && 스토어목록.length > 0 && (
                    <StoreGrid>
                        {스토어목록.map((스토어) => (
                            <StoreCard
                                key={스토어.uuid}
                                onClick={() => navigate(`/stores/${스토어.uuid}/channels`)}
                            >
                                <CardBody>
                                    <StoreNameRow>
                                        <StoreIcon src={스토어.logo_image_url} alt="" />
                                        <StoreName>{스토어.name ?? '이름 없음'}</StoreName>
                                    </StoreNameRow>
                                    {스토어.bio && (
                                        <StoreDescription>{스토어.bio}</StoreDescription>
                                    )}
                                </CardBody>
                                {스토어.virtualNumber && (
                                    <CardFooter>
                                        <VirtualNumber>{스토어.virtualNumber}</VirtualNumber>
                                    </CardFooter>
                                )}
                            </StoreCard>
                        ))}
                    </StoreGrid>
                )}
            </Contents>

            {모달열림 && (
                <StoreModal
                    onClose={() => set모달열림(false)}
                    onSuccess={데이터로드}
                />
            )}
        </PageWrapper>
    );
};


const PageWrapper = styled.div`
    width: 100%;
    min-height: 100dvh;
    background: #f7f8fa;
`;

const Contents = styled.div`
    max-width: 960px;
    margin: 0 auto;
    padding: 80px 16px 48px;
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
`;

const PageTitle = styled.h1`
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 700;
    color: #111111;
    margin: 0;
`;

const StoreGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
`;

const StoreCard = styled.div`
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 12px;
    padding: 24px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &:hover {
        background: #f5f8ff;
        border-color: #487BFD;
    }
`;

const CardBody = styled.div`
    flex: 1;
`;

const StoreNameRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const StoreIcon = styled.img`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    background: #eeeeee;
    border: 1px solid #e0e0e0;
`;

const StoreName = styled.span`
    display: block;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 600;
    color: #111111;
`;

const StoreDescription = styled.span`
    display: block;
    margin-top: 8px;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 400;
    color: #777777;
    line-height: 160%;
`;

const CardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const VirtualNumber = styled.span`
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 600;
    color: #487BFD;
    letter-spacing: 0.05em;
`;

const StatusText = styled.span`
    display: block;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 400;
    color: ${({ $error }) => ($error ? '#EF4444' : '#aaaaaa')};
`;


export default StoresPage;
